<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="playType.length">
              <div
                class="article_con"
                v-for="(play, index) in playType"
                :key="index"
              >
                <div class="article_title">{{ play.dictLabel }}</div>
                <div class="article_r" v-if="list[index] && list[index].length">
                  <!-- 剧目介绍 -->
                  <div
                    class="content_item"
                    v-for="(item, ind) in list[index]"
                    :key="ind"
                    @click="toDetail(item.id)"
                  >
                    <div class="content_item_img" v-if="item.coverImg">
                      <img v-lazy="item.coverImg" />
                    </div>
                    <div class="content_item_title">
                      <p class="title">{{ item.title }}</p>
                      <p class="desc">{{ item.details.theater }}</p>
                      <p class="desc">{{ item.details.artisticForm }}</p>
                      <p class="desc">
                        {{ $t('director') }}&nbsp;&nbsp;{{
                          item.details.director
                        }}
                      </p>
                      <div class="content_item_d">
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/time_icon.png" />
                            {{ $t('time') }}
                          </div>
                          <div class="item_d_r">
                            {{ item.details.performanceTime }}
                            <!-- {{ item.startTime + ' | ' + item.endTime }} -->
                          </div>
                        </div>
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/site_icon.png" />
                            {{ $t('site') }}
                          </div>
                          <div class="item_d_r">{{ item.details.site }}</div>
                        </div>
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/duration_icon.png" />
                            {{ $t('duration') }}
                          </div>
                          <div class="item_d_r">
                            {{ item.details.duration }}
                          </div>
                        </div>
                      </div>
                      <div class="perform_type">
                        <span>{{ item.details.language }}</span>

                        <!-- <span>波兰语演出</span>
                        <span>|</span>
                        <span>中英文字幕</span> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content_top" v-else>
                  <el-empty :description="$t('noData')"></el-empty>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="playType.length">
              <div class="article_con">
                <div class="article_tab">
                  <div
                    :class="['tab_item', currentIndex == index ? 'active' : '']"
                    v-for="(t, index) in playType"
                    :key="index"
                    @click="handleTab(t, index)"
                  >
                    {{ t.dictLabel }}
                  </div>
                </div>
                <!-- 剧目介绍 -->
                <div class="content_list" v-if="appList.length">
                  <div
                    class="content_item"
                    v-for="(item, index) in appList"
                    :key="index"
                    @click="toDetail(item.id)"
                  >
                    <div class="content_item_u">
                      <div class="content_item_img" v-if="item.coverImg">
                        <img v-lazy="item.coverImg" />
                      </div>
                      <div class="content_item_title">
                        <p class="title">{{ item.title }}</p>
                        <p class="desc">{{ item.details.theater }}</p>
                        <p class="desc">{{ item.details.artisticForm }}</p>
                        <p class="desc">
                          {{ $t('director') }}&nbsp;&nbsp;{{
                            item.details.director
                          }}
                        </p>
                        <div class="perform_type">
                          <span>{{ item.details.language }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="content_item_d">
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/time_icon.png" />{{
                            $t('time')
                          }}
                        </div>
                        <div class="item_d_r">
                          {{ item.details.performanceTime }}
                        </div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/site_icon.png" />{{
                            $t('site')
                          }}
                        </div>
                        <div class="item_d_r">{{ item.details.site }}</div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/duration_icon.png" />{{
                            $t('duration')
                          }}
                        </div>
                        <div class="item_d_r">{{ item.details.duration }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content_top" v-else>
                  <el-empty :description="$t('noData')"></el-empty>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab } from '@/const';
import { fetchConentList, getDicts } from '@/assets/api';
export default {
  name: 'InvitedPlay',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: themeTab,
      cloumnId: null, //栏目id
      tabLeft: [
        { name: '璀璨国际' },
        { name: '经典重构' },
        { name: '大师佳作' },
      ],
      playType: [],
      list: [
        // {
        //   id: 6,
        //   img: require('@/assets/img/homeimgs/activity_03.png'),
        //   title: '南浔百间楼1',
        //   unit: '窦辉工作室',
        //   adapt: '改编自威廉·莎士比亚剧作',
        //   director: '导演  窦辉',
        //   startTime: '10月17日19:30',
        //   endTime: '10月18日19:30',
        //   site: '北栅粮仓一号馆1A',
        //   duration: '60分钟 ( 无中场休息 )',
        // },
      ],
      list2: [],
      list3: [],
      appList: [],
      id: '',
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.getPayType();
  },
  methods: {
    getPayType() {
      getDicts('play_type').then((res) => {
        if (res.code == 200) {
          this.playType = res.data;
          this.getList();
        }
      });
    },
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    handleTab(t, index) {
      this.currentIndex = index;
      this.appList = this.list[index];
    },

    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.playType.map((p, index) => {
          const list = res.records.filter(
            (r) => r.details.newType == p.dictValue
          );
          this.$set(this.list, index, list);
        });
        if (this.currentIndex == 0) {
          this.appList = this.list[0];
        }
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/invitedPlayDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      margin-top: 2.75rem;
      .article_title {
        height: 3.75rem;
        line-height: 3.75rem;
        padding-left: 1.5rem;
        box-sizing: border-box;
        width: 100%;
        background: linear-gradient(to right, #aae5ef 0%, #b1bbff 100%);
        font-size: 1.5rem;
        color: #424451;
        margin-bottom: 1.75rem;
      }
      .article_r {
        display: flex;
        flex-wrap: wrap;
        .content_item {
          flex: 0 0 calc((100% - 40px) / 3);
          text-align: left;
          margin: 0 20px 20px 0;
          overflow: hidden;
          background: rgba(255, 255, 255, 0);
          border: 6px solid rgba(255, 255, 255, 0);
          &:nth-child(3n) {
            /* 去除第3n个的margin-right */
            margin-right: 0;
          }
          &:hover {
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            border: 6px solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
          }
          .content_item_img {
            width: 100%; /* 宽度自适应父容器 */
            background: #fff;
            img {
              aspect-ratio: 3/4; /* 宽高比 3:4 */
              width: 100%; /* 宽度自适应父容器 */
              object-fit: cover;
              object-position: center; /* 图片的中心与容器的中心对齐 */
            }
          }
          .content_item_title {
            padding: 1rem 0.3125rem 0.3125rem;
            background: #fff;
            min-height: 18.375rem;
            height: 100%;
            .title {
              font-size: 1.125rem;
              color: #333;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              padding: 0 1.25rem;
            }
            .desc {
              font-size: 0.875rem;
              color: #6b6d7a;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              margin: 0.375rem 0;
              padding: 0 1.25rem;
            }
            .content_item_d {
              margin-top: 0.625rem;
              background: #f6f6f6;
              padding: 0.3125rem 0.625rem;
              .item_d {
                display: flex;
                justify-content: flex-start;
                font-size: 0.875rem;
                margin: 0.3125rem 0;
                .item_d_l {
                  display: flex;
                  align-items: flex-start;
                  width: 4.375rem;
                  font-family: SourceHanSansCN-Medium;
                  img {
                    width: 1.25rem;
                    height: 1.25rem;
                  }
                }
                .item_d_lEn {
                  min-width: 6rem;
                  font-size: 1rem;
                  margin-top: -0.3125rem;
                }
                .item_d_r {
                  display: inline-block;
                  color: #6b6d7a;
                  margin-left: 0.3125rem;
                }
              }
            }
            .perform_type {
              display: flex;
              align-items: center;
              margin: 0.5rem;
              span {
                font-size: 0.875rem;
                color: #6b6d7a;
                margin-right: 0.3125rem;
              }
            }
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
    padding-bottom: 1.6667rem;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .article_con {
      background: #fff;
      width: 100%;

      .article_tab {
        width: 100%;
        display: flex;
        margin-bottom: 1.6667rem;
        .tab_item {
          padding: 0 1rem;
          background: #f0f1f2;
          margin-right: 1.1667rem;
          height: 2rem;
          line-height: 2rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            background: #6b6d7a;
            color: #fff;
            overflow: visible;
            text-overflow: clip;
            flex: 0 0 auto; // 不再压缩，宽度由内容撑开
            max-width: none; // 允许自动放大
            z-index: 2; // 避免被其他 li 遮挡
            transition: all 0.3s;
          }
        }
      }
      .content_list {
        .content_item {
          flex: 0 0 calc((100% - 40px) / 3);
          text-align: left;
          margin-bottom: 1.6667rem;
          overflow: hidden;
          background: rgba(255, 255, 255, 0);
          border: 6px solid rgba(255, 255, 255, 0);

          .content_item_u {
            display: flex;
            background: #f0f1f2;
            height: auto;
            align-items: stretch;
            min-height: 8.3333rem; /* 可选：设置最小高度，防止内容过少时塌陷 */
            .content_item_img {
              width: 27.8%;
              min-height: inherit; /* 确保继承最小高度 */
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center; /* 图片的中心与容器的中心对齐 */
              }
            }
            .content_item_title {
              flex: 1;
              padding: 1rem 0.3125rem 0.3125rem;
              background: #f0f1f2;
              .title {
                font-size: 1.1667rem;
                color: #333;
                display: -webkit-box; /* 旧版 Flex 布局 */
                -webkit-line-clamp: 2; /* 限制行数 */
                -webkit-box-orient: vertical; /* 垂直排列 */
                overflow: hidden; /* 隐藏溢出 */
                text-overflow: ellipsis;
                padding: 0 1.25rem;
                font-family: SourceHanSansCN-Medium;
              }
              .desc {
                font-size: 0.8333rem;
                color: #6b6d7a;
                display: -webkit-box; /* 旧版 Flex 布局 */
                -webkit-line-clamp: 2; /* 限制行数 */
                -webkit-box-orient: vertical; /* 垂直排列 */
                overflow: hidden; /* 隐藏溢出 */
                text-overflow: ellipsis;
                margin: 0.375rem 0;
                padding: 0 1.25rem;
              }
              .perform_type {
                display: flex;
                align-items: center;
                margin: 0.375rem 0;
                padding: 0 1.25rem;
                span {
                  font-size: 0.8333rem;
                  color: #6b6d7a;
                  margin-right: 0.3125rem;
                }
              }
            }
          }

          .content_item_d {
            margin-top: 0.625rem;
            padding: 0.3125rem 1.3333rem;
            .title {
              font-size: 1.1667rem;
              color: #333;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              margin-bottom: 12px;
              font-family: SourceHanSansCN-Medium;
            }
            .item_d {
              display: flex;
              justify-content: flex-start;
              font-size: 0.8333rem;
              margin: 0.3125rem 0;
              .item_d_l {
                display: flex;
                align-items: center;
                font-family: SourceHanSansCN-Medium;
                img {
                  width: 1.25rem;
                  height: 1.25rem;
                }
              }
              .item_d_r {
                display: inline-block;
                color: #6b6d7a;
                margin-left: 0.3125rem;
              }
            }
          }
        }
      }
      .article_unit {
        .artical_img {
          width: 100%;
          height: auto;
        }
        h3 {
          font-size: 2.25rem;
          color: #424451;
          padding-bottom: 0.3333rem;
          border-bottom: 0.1667rem solid;
          border-image: linear-gradient(
              90deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          margin-bottom: 3.75rem;
          text-align: center;
        }
        .detail_con {
          color: #666;
          font-size: 1.125rem;
        }
        .thank_list {
          margin-top: 2rem;
          .thank_title {
            height: 2.8333rem;
            line-height: 2.8333rem;
            padding-left: 1rem;
            box-sizing: border-box;
            width: 100%;
            background: linear-gradient(to right, #aae5ef 0%, #b1bbff 100%);
            font-size: 1.1667rem;
            color: #424451;
          }
        }
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
